import React from 'react'
import '../MRUDegree/style.scss'

const thSection = (label) => (
	<tr>
		<th colSpan={2} style={{ backgroundColor: '#0c1c2c' }}>
			<strong>{label}</strong>
		</th>
		<th style={{ backgroundColor: '#0c1c2c' }}>
			<strong>CREDITS</strong>
		</th>
		<th style={{ backgroundColor: '#0c1c2c' }}>
			<strong>HOURS</strong>
		</th>
	</tr>
)

const courseRow = (code, title, credits, hours) => (
	<tr>
		<td style={{ backgroundColor: '#43586d' }}>{code}</td>
		<td style={{ textAlign: 'left' }}>{title}</td>
		<td>{credits}</td>
		<td>{hours}</td>
	</tr>
)

function MRUBobDegreePlanModal() {
	return (
		<div id="tuition-modal" className="grid-12 c5 padd padd-top-2 padd-bottom-2">
			<div className="intro fs-125">
				<h2>Degree Plan</h2>
			</div>
			<div className="table container fs-85">
				<p className="fs-85 w-100 span-12" style={{ padding: '0 0 0.5em', margin: 0 }}>
					Bachelor of Business &amp; Healthcare Management Degree Plan
				</p>
				<table>
					<tbody>
						<tr>
							<th colSpan={4} style={{ backgroundColor: '#D3B077' }}>
								<strong>BACHELOR OF BUSINESS &amp; HEALTHCARE MANAGEMENT</strong>
							</th>
						</tr>

						{thSection('GENERAL EDUCATION COURSES')}
						{courseRow('ENC1101', 'English Composition I', 3, 45)}
						{courseRow('ENC1102', 'English Composition II', 3, 45)}
						{courseRow('SPC2324', 'Speech and Debate', 3, 45)}
						{courseRow('PSY2012', 'General Psychology', 3, 45)}
						{courseRow('SOC1201', 'Principles of Sociology', 3, 45)}
						{courseRow('ECO2013', 'Principles of Macroeconomics', 3, 45)}
						{courseRow('ECO2023', 'Principles of Microeconomics', 3, 45)}
						{courseRow('MAC1105', 'College Algebra', 3, 45)}
						<tr>
							<td style={{ backgroundColor: '#43586d' }}>
								STA2023
								<br />
								<strong>or</strong>
								<br />
								MAC2205
							</td>
							<td style={{ textAlign: 'left' }}>
								Introduction to Statistics
								<br />
								<strong>or</strong>
								<br />
								Application for Statistical Methods
							</td>
							<td>3</td>
							<td>45</td>
						</tr>
						{courseRow('CGS 2100', 'Introduction to Information Technology', 3, 45)}
						{courseRow('COM1201', 'Introduction to Communication', 3, 45)}
						{courseRow('SLS1001', 'Academic Success', 1.5, 22.5)}
						{courseRow('SLS2012', 'Career & Professional Planning', 1.5, 22.5)}
						{courseRow('—', 'Science Elective', 3, 45)}
						{courseRow('—', 'Humanities Elective', 3, 45)}
						<tr>
							<td colSpan={2}>Total General Education Courses:</td>
							<td>39</td>
							<td>585</td>
						</tr>

						{thSection('FOUNDATION COURSES')}
						{courseRow('BUS1011', 'Introduction to Business', 3, 45)}
						{courseRow('ACG1001', 'Principles of Accounting I', 3, 45)}
						{courseRow('ACG2100', 'Principles of Accounting II', 3, 45)}
						{courseRow('FIN2001', 'Introduction to Finance', 3, 45)}
						{courseRow('BUL2101', 'Business Law I', 3, 45)}
						{courseRow('BUL2242', 'Business Law II', 3, 45)}
						{courseRow('MAN2345', 'Principles of Supervision & Management', 3, 45)}
						{courseRow('MKT1011', 'Principles of Marketing', 3, 45)}
						{courseRow('MKT2322', 'Integrated Marketing Communication', 3, 45)}
						{courseRow('HCM1100', 'Survey of Healthcare Management', 3, 45)}
						{courseRow('HCM2300', 'Ethical & Legal Issues in Healthcare', 3, 45)}
						<tr>
							<td colSpan={2}>Total Foundation Courses:</td>
							<td>33</td>
							<td>495</td>
						</tr>

						{thSection('ADVANCED BUSINESS & HEALTHCARE COURSES')}
						{courseRow('ISM 3011', 'Information Systems in Healthcare', 3, 45)}
						{courseRow('MAN3600', 'Management of International Business', 3, 45)}
						{courseRow('MAN3151', 'Leadership & Organizational Behavior', 3, 45)}
						{courseRow('HCM3340', 'Healthcare Human Resources', 3, 45)}
						{courseRow('GEB3213', 'Business Communications', 3, 45)}
						<tr>
							<td style={{ backgroundColor: '#43586d' }}>
								MAN3113
								<br />
								<strong>or</strong>
								<br />
								HCM3100
							</td>
							<td style={{ textAlign: 'left' }}>
								Entrepreneurship
								<br />
								<strong>or</strong>
								<br />
								Elective (Current Issues in Healthcare)
							</td>
							<td>3</td>
							<td>45</td>
						</tr>
						{courseRow('QMB3600', 'Quantitative Methods for Decision Making', 3, 45)}
					</tbody>
				</table>
			</div>
		</div>
	)
}

export default MRUBobDegreePlanModal
